import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
} from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useRef } from "react";

const ImageSlider = ({ productImages = [], searchQuery }) => {
  const navigate = useNavigate();

  const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const handleBack = () => {
    if (searchQuery) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  return (
    <div
      className="relative"
      style={{
        width: smallScreen ? "100%" : "50%",
        borderRadius: smallScreen ? "0" : "24px",
        overflow: "hidden",
        boxShadow: smallScreen ? "none" : "0 4px 24px rgba(0,0,0,0.08)"
      }}
    >
      <button
        className="flex justify-center items-center absolute top-4 left-4 p-2.5 bg-white hover:bg-gray-50 rounded-full z-20 transition-all shadow-lg hover:shadow-xl"
        onClick={handleBack}
        style={{
          border: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <ArrowBackIosOutlined sx={{ fontSize: "20px", color: "#1a1a1a", pl: "2px" }} />
      </button>

      <button
        ref={prevRef}
        className="md:flex justify-center items-center absolute left-3 top-1/2 -translate-y-1/2 bg-[#B7B7B7]/70 hover:bg-[#B7B7B7] rounded-full p-2 z-10 transition"
      >
        <ArrowBackIosOutlined sx={{ color: "#fff", fontSize: "20px" }} />
      </button>

      <button
        ref={nextRef}
        className="md:flex justify-center items-center absolute right-3 top-1/2 -translate-y-1/2 bg-[#B7B7B7]/70 hover:bg-[#B7B7B7] rounded-full p-2 z-10 transition"
      >
        <ArrowForwardIosOutlined sx={{ color: "#fff", fontSize: "20px" }} />
      </button>

      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        pagination={{
          type: "custom",
          renderCustom: (swiper, current, total) => {
            let dots = "";
            for (let i = 1; i <= total; i++) {
              dots += `
                <span
                  class="w-[15px] h-[4px] ${
                    current === i ? "bg-[#DEA5BA]" : "bg-[#D9D9D9]"
                  } rounded-[2px] mx-1 inline-block transition-all duration-300"
                ></span>
              `;
            }
            return `<div class="flex justify-center mt-4">${dots}</div>`;
          },
          clickable: true,
        }}
        spaceBetween={20}
        slidesPerView={1}
        style={{ paddingBottom: "30px" }}
      >
        {productImages.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Product Detail ${index + 1}`}
              loading="lazy"
              className="w-full h-[55vh] md:h-auto object-cover object-top md:object-contain rounded-none md:rounded-lg md:aspect-[5/6] lg:aspect-[4/3.9] transition-all duration-300"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
